import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { defaultAreaId, reportingYear } from "../../../constants";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import AreaChooser from "../../choosers/AreaChooser";
import ShareOfUsersWithinPrivateSectorByMethodChart from "./ShareOfUsersWithinPrivateSectorByMethodChart";

const ShareOfUsersWithinPrivateSectorByMethodChartWidget = props => {
  const [areaId, setAreaId] = useState(defaultAreaId);

  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId="share_of_users_within_private_sector_by_method_chart"
      reference="Figure 3.2"
      title={`Share of Users within Private Sector, ${reportingYear}`}
      subtitle="Comparison by Method"
      contentWidth={400}
      filters={[
        <AreaChooser
          id="figure-3-2"
          label="Select Country or Country Group"
          areas={props.database.areas}
          includeCountries={true}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: "theme3.shareOfUsersWithinPrivateSectorByMethodChart",
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      initialAbsolute={false}
      chartRef={ref}
      chartSettings={{
        area: props.database.areas[areaId].area
      }}
      downloadAbsoluteValues={true}
    >
      <ShareOfUsersWithinPrivateSectorByMethodChart
        ref={ref}
        data={props.data}
      />
    </AbsoluteChartToggleFrame>
  );
};

ShareOfUsersWithinPrivateSectorByMethodChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ShareOfUsersWithinPrivateSectorByMethodChartWidget;
